import accountApi from '../api/account-api';

const initialState = () => {
  return {
    multiOfficeAccounts: [],
  };
};

const getters = {
  getMultiOfficeAccounts(state) {
    return state.multiOfficeAccounts;
  },
};

const mutations = {
  setMultiOfficeAccounts(state, data) {
    state.multiOfficeAccounts = data;
  },
};

const actions = {
  async loadMultiAccounts({ commit }) {
    const response = await accountApi.loadMultiAccounts();

    if (response.status === 204) {
      commit('setMultiOfficeAccounts', []);
    } else {
      commit('setMultiOfficeAccounts', response.data?.data || []);
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
  strict: process.env.NODE_ENV !== 'production',
};
